<template>
  <div class="min-h-screen bg-noir-950 text-cream-100">
    <slot />
  </div>
</template>
